// extracted by mini-css-extract-plugin
export default {"button":"styles_button__C3brN","label":"styles_label__sttiy","icon":"styles_icon__vKHW9"};